import FeedbackReportForm from './FeedbackReportForm';

export default FeedbackReportForm;
